;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/projects/:projectId\",\"regex\":\"^/projects/([^/]+)$\",\"paramNames\":[\"projectId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/auth/change-password\"},{\"path\":\"/auth/forgot-password\"},{\"path\":\"/auth/reset-password\"},{\"path\":\"/auth/sign-in\"},{\"path\":\"/auth/sign-up\"},{\"path\":\"/policies/privacy-policy\"},{\"path\":\"/projects\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.0.10";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_ENV ?? 'prod',
  tracesSampleRate: process.env.NEXT_PUBLIC_ENV === 'stage' ? 0.1 : 0.1,
  debug: false,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

  // IMPORTANT: for distributed tracing headers (optional but recommended)
  // tracePropagationTargets: ['localhost', /^https:\/\/api\./],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
